var angular:angular.IAngularStatic =  require('angular');
export default angular.module('prmTranslate', []);
    import './prmMissingTranslationHandler.factory';
    import './prmTranslatePlaceholder.factory';
    import './prmTranslationIdToCodeMapping.factory';






// WEBPACK FOOTER //
// ./src/main/webapp/components/translate/prmTranslate.module.ts